<!-- Carousel -->
<div id="demo" class="carousel slide" data-bs-ride="carousel" data-interval="3000">

  <!-- Indicators/dotsdata-interval="3000" -->
  <div class="carousel-indicators">
    <button type="button" data-bs-target="#demo" data-bs-slide-to="0" class="active"></button>
    <button type="button" data-bs-target="#demo" data-bs-slide-to="1"></button>
    <button type="button" data-bs-target="#demo" data-bs-slide-to="2"></button>
  </div>

  <!-- The slideshow/carousel -->
  <div class="carousel-inner">
    <div class="carousel-item item-1 active">
      <!-- <img src="assets/3_bg.jpg" alt="Los Angeles" class="d-block w-100"> -->
      <div class="content">
        <h2>MEN COLLECTION</h2>
        <h3>SAVE UP TO 75% OFF</h3>
        <button mat-button class="btn btn-shop" [routerLink]="['/products']" 
        >SHOP NOW</button>
      </div>
    </div>
    <div class="carousel-item item-2">
      <div class="content">
        <h2>WOMEN COLLECTION</h2>
        <h3>SAVE UP TO 85% OFF</h3>
        <button mat-button class="btn btn-shop" [routerLink]="['/products']" 
        >SHOP NOW</button>
      </div>
    </div>
    <div class="carousel-item item-3">
      <div class="content">
        <h2>WOMEN DRESS COLLECTION</h2>
        <h3>SAVE UP TO 45% OFF</h3>
        <button mat-button class="btn btn-shop" [routerLink]="['/products']" 
        >SHOP NOW</button>
      </div>
    </div>
  </div>

  <!-- Left and right controls/icons -->
  <button class="carousel-control-prev" type="button" data-bs-target="#demo" data-bs-slide="prev">
    <span class="carousel-control-prev-icon"></span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#demo" data-bs-slide="next">
    <span class="carousel-control-next-icon"></span>
  </button>
</div>

<section class="section-products" *ngIf="products.length > 0">
  <div class="container">

    <div class="row text-left">
      <div class="col-md-12 col-lg-12">
        <div class="header">
          <h2>Buy With Category</h2>
        </div>
      </div>
    </div>
    <div class="row">
      <!-- Single Product -->
      <div class="col-md-6 col-lg-4 col-xl-3" *ngFor="let category of categories">
        <div id="product-1" [routerLink]="['/product-category']" [queryParams]="{category: category}" class="single-product category-product">
          <div class="part-1">
            <img src="{{ checkImage(category) }}" alt="" class="img-fluid">
            <h4 class="new">{{ category }}</h4>
          </div>
          <div class="part">
            <h3 class="product-title category">{{ category }}</h3>
          </div>
        </div>
      </div>
    </div>
    <hr>
    <div class="row text-left mt-5">
      <div class="col-md-12 col-lg-12">
        <div class="header">
          <h2>Featured Products</h2>
        </div>
      </div>
    </div>
    <div class="row">
      <!-- Single Product -->
      <div class="col-md-6 col-lg-4 col-xl-3" *ngFor="let product of products">
        <div id="product-1" class="single-product">
          <div class="part-1">
            <img src="{{ product.image }}" alt="" class="img-fluid">
            <ul>
              <li><a (click)="addFavourite(product)"><i class="fa fa-heart"></i></a></li>
            </ul>
            <h4 class="new">{{ product.category }}</h4>
          </div>
          <div class="part-2">
            <h3 class="product-title">{{ product.title }}</h3>
            <h4 class="product-price price">₹{{ product.price}}</h4>


            <div class="d-flex justify-content-between align-items-center">
              <div class="">
                <h4 class="product-price rating mb-0"><i class="fa fa-star" aria-hidden="true"></i>
                  {{product.rating.rate}}</h4>
                <h4 class="product-price count mb-0">({{product.rating.count}})</h4>
              </div>
              <button class="btn btn-sm py-0" mat-button [routerLink]="['/product' , product.id]">Details</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 text-center">
        <button class="btn py-0" mat-button [routerLink]="['/products']">View All</button>
    </div>

  </div>
</section>

<div *ngIf="products.length == 0">
  <ngx-spinner size="medium" type="ball-fussion"></ngx-spinner>
</div>
